<template>
<div class="row justify-content-center contenido">
	<div class="col-12 col-md-12 col-lg-12  col-xl-12">
		<div class="foco-intro">
			<p v-html="$t('cover.text_intro')"></p>
			
		</div>
	</div>	
</div>
</template>

<script> 
export default {
	name: 'Contenido'
	
}
</script>